import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import VCharts from 'v-charts';

import { Navbar, Field, Search, Picker, Radio,DatetimePicker,  Popup, Toast, Cell, Button, Switch, TabItem, InfiniteScroll, Lazyload, Header } from 'mint-ui';
import birthdayPicker from '@/components/birthdayPicker'
import '@/styles/index.css';
import '@/styles/index.scss'; // global css
import 'mint-ui/lib/style.css';

import App from './App';
import router from './router';
import store from './store';
import i18n from './lang';
import './utils/sysdic';
import './utils/number';

import '@/icons'; // icon
import '@/permission'; // permission control

import format from 'vue-text-format';

Vue.use(format);
Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});

Vue.use(VCharts);

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);


Vue.component('birthdayPicker', birthdayPicker);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Header.name, Header);
Vue.component(Cell.name, Cell);
Vue.component(Button.name, Button);
Vue.component(Switch.name, Switch);
Vue.component(Popup.name, Popup);
Vue.component(Field.name, Field);
Vue.component(Picker.name, Picker);
Vue.component(Search.name, Search);
Vue.component(Radio.name, Radio);
Vue.component(DatetimePicker.name, DatetimePicker);

Vue.use(InfiniteScroll);
Vue.use(Lazyload);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js